module.exports = __webpack_public_path__ + "static/media/06_MEDS-1.7-EC-10 1.46fa1be5.svg";